export default __webpack_public_path__ + "static/mousePic2-da0af07dff6680d4cd966492e685100f.jpg";